import { render, staticRenderFns } from "./PermissionRoleDetailTop.vue?vue&type=template&id=4da9ce6a&scoped=true&"
import script from "./PermissionRoleDetailTop.vue?vue&type=script&lang=js&"
export * from "./PermissionRoleDetailTop.vue?vue&type=script&lang=js&"
import style0 from "./PermissionRoleDetailTop.vue?vue&type=style&index=0&id=4da9ce6a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4da9ce6a",
  null
  
)

export default component.exports